import React, { useEffect, useState } from "react";
import { each, isEmpty, map } from "lodash";
import { useFetchDeviceSettings } from "components/memberships/api";
import { useMutation } from "react-query";
import { fetchApi } from "helpers/reactQueryApi";
import { FormProvider, useForm } from "react-hook-form";
import CheckboxFieldWrapper from "components/shared/form/fields/CheckboxFieldWrapper";
import Checkbox from "components/shared/form/fields/Checkbox";
import FormActions from "components/shared/form/fields/FormActions";

export default function PushNotificationSettingsForm() {
  const [deviceId, setDeviceUniqueId] = useState("");
  const [deviceName, setDeviceName] = useState("");

  const { data, refetch } = useFetchDeviceSettings(deviceId);

  function getDeviceUniqueId() {
    window.bridge?.getDeviceUniqueId(({ id, name }) => {
      setDeviceUniqueId(id);
      setDeviceName(name);
    });
  }

  useEffect(() => {
    getDeviceUniqueId();
  });

  useEffect(() => {
    deviceId !== "" && refetch();
  }, [deviceId]);

  function retryDeviceLoading() {
    if (deviceId != "" && isEmpty(data)) {
      window.bridge?.askToRegisterDevice();
    } else {
      getDeviceUniqueId();
    }
  }

  const methods = useForm();
  const { handleSubmit, setValue } = methods;

  useEffect(() => {
    if (data)
      each(data.notifications, (settings, label) => {
        each(settings, (setting, key) => setValue(`${label}.${key}`, setting));
      });
  }, [data]);

  const { mutate: updateDeviceSettings } = useMutation(
    (body: { notifications: { [key: string]: boolean } }) =>
      fetchApi(`/api/v1/devices/${deviceId}/settings`, {
        method: "POST",
        body,
      }),
    {
      onSuccess: () =>
        toastr.success(
          I18n.t(
            "js.memberships.settings.push_notifications.submission_success",
          ),
        ),
    },
  );

  function submit(data) {
    updateDeviceSettings({ notifications: data });
  }

  return !isEmpty(deviceId) && !isEmpty(data) ? (
    <FormProvider {...methods}>
      <h3>{I18n.t("js.memberships.settings.push_notifications.tab")}</h3>
      <div
        className="markdown-content prose break-words max-w-prose mb-3"
        dangerouslySetInnerHTML={{
          __html: I18n.t(
            "js.memberships.settings.push_notifications.description",
            { deviceName },
          ),
        }}
      />
      <form className="form-horizontal" onSubmit={handleSubmit(submit)}>
        {map(data.notifications, (settings, label) => {
          return (
            <CheckboxFieldWrapper
              label={I18n.t(
                `js.memberships.settings.push_notifications.${label}.label`,
              )}
            >
              {map(settings, (setting, key) => (
                <>
                  <Checkbox
                    name={`${label}.${key}`}
                    label={I18n.t(
                      `js.memberships.settings.push_notifications.${label}.${key}`,
                    )}
                  />
                </>
              ))}
            </CheckboxFieldWrapper>
          );
        })}
        <FormActions />
      </form>
    </FormProvider>
  ) : (
    <div className="flex flex-col">
      <p>{I18n.t("js.memberships.settings.push_notifications.no_settings")}</p>
      <button
        className="btn btn-primary flex justify-center"
        onClick={retryDeviceLoading}
      >
        {I18n.t("js.generic_try_again")}
      </button>
    </div>
  );
}
